import type { FaireProductEntity } from "../../entity_types/product";

export const p_743agkha05: FaireProductEntity = {
  token: "p_743agkha05",
  type: "product",
  name: "Hot Tango",
  brandToken: "b_4ruezpily0",
  brandName: "Tango",
  imageUrl:
    "https://cdn.faire.com/fastly/5cc7876aa6ee0d48bba8e9da38c55655712005285d94c2137d15cfb947dc5de2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4eff87dc81152ad47e12a3f3db1474586b70af20aed590c9f2d1c462d7ba98f0.jpeg",
    "https://cdn.faire.com/fastly/71ebcc74f4249d8e26d856775f2e34b78eadc9d4e95b51f83c4e2d16ed39b9c5.jpeg",
    "https://cdn.faire.com/fastly/3bd2acabacad45fe73bd774e8a26c3d38d495934e4b42353df9a199fc1d6f601.jpeg",
    "https://cdn.faire.com/fastly/7302f399529d2e18a6f2c7fc1100f4fe907d3546dfd19a7d0a569ffed89b6b2e.jpeg",
    "https://cdn.faire.com/fastly/6407a26e0c9cc8689833450bbf2bc003d3599e2632eef8058f2446315e269ec5.jpeg",
    "https://cdn.faire.com/fastly/af397877755718dc549c05490cfdf3e9a51c071a88e366a0ce2330c6da972698.jpeg",
    "https://cdn.faire.com/fastly/b9abab4d656fd7b9dd43f6a579da22b9fb3a7ea7d1605631bda38cc01e6cd2e1.jpeg",
    "https://cdn.faire.com/fastly/cd69a3f462721fdf604a49ab332c2405f401d36505242ea9af099b23ba7a92ef.jpeg",
    "https://cdn.faire.com/fastly/c129dd7e1410253923aa887a883bfa9f05a1443108d45cd53188f5381e2e2fbd.jpeg",
    "https://cdn.faire.com/fastly/f07fe7c0e36fc6d81962cf1cd58968c15952b69c2386dbd8c77ac61343f1ff75.jpeg",
    "https://cdn.faire.com/fastly/aff2b33375c5687bf5b02fb835cf650eeacce2efe7043c4a83c6813ee54b2155.jpeg",
    "https://cdn.faire.com/fastly/14975064bd4b906f745446a10525d66a3c83002feb2f846af774104fbb2800f6.jpeg",
    "https://cdn.faire.com/fastly/c2f83da90246fb55f2129a323c81cfe37f1f091fb5c15a8d0a17aabe4c80737a.jpeg",
    "https://cdn.faire.com/fastly/6978f71cc90793134383332740d6b6186b82fd2294ee1e608caa8c369c14831f.jpeg",
    "https://cdn.faire.com/fastly/9817cde50e15584e7bee34e2e47bc0b641c06682cf6e891313b16a52996ce944.jpeg",
    "https://cdn.faire.com/fastly/bc074eb36c44bac7cb708ab1fdb4dc4d4e4bae3e1c89271b2bb786eef1fa41b2.png",
    "https://cdn.faire.com/fastly/ab9f564308446084474f6cb5f850d55c4172ee9bdc22a704eb1f6135120678ba.png",
    "https://cdn.faire.com/fastly/f9dca3f29d8a9460df9bb1030058d1a5ba23a11d553f7ad49929447127f4ec48.png",
    "https://cdn.faire.com/fastly/4db42110eb697ca6fb4bda3395eeb5c9827310c7ffb89bf7a7b589f25bf5865b.jpeg",
  ],
  priceDollars: 6,
  description:
    "Hot Tango is the crowd favorite, and there's no wonder why. Signature delicious Tango flavor with all the heat you need. If you're already a fan of hot sauce, this one's for you. It's a must.\n\nIngredients: Carrots, Apple Cider Vinegar, Garlic, Limes, Chile Peppers, Sawtooth Cilantro, and Sea Salt",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:09.894Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
